import React, { useContext, useEffect, useState } from "react";
import useStyles from "./styles";
import { Grid } from "@material-ui/core";
import { ColProps_2 } from "@core/utils/ColProps";
import { useParams } from "react-router-dom";
import { getMarketPairDisplay } from "@core/utils/getCurrencyMeta";
import walletsApi from "@api/wallets";
import CustomInput from "./CustomInput";
import { MarketContext } from "@context/MarketContext";

const LimitOrder = () => {
  const classes = useStyles();
  const { currencyName } = useParams();
  const market = useContext(MarketContext);
  const { quoteName, baseUnit, quoteUnit } = getMarketPairDisplay(currencyName);
  const [state, setState] = useState({
    SellInventory: 0,
    BuyInventory: 0,
  });

  useEffect(() => {
    walletsApi
      .getMyWalletByCurrency({
        params: {
          currencyName: quoteUnit,
        },
      })
      .then((data) => {
        setState((prevState) => ({
          ...prevState,
          BuyInventory: data?.content?.availableBalance,
        }));
      })
      .catch((data) => {});

    walletsApi
      .getMyWalletByCurrency({
        params: {
          currencyName: baseUnit,
        },
      })
      .then((data) => {
        setState((prevState) => ({
          ...prevState,
          SellInventory: data?.content?.availableBalance,
        }));
      })
      .catch((data) => {});
  }, [currencyName, market.forceUpdate, baseUnit, quoteUnit]);

  return (
    <Grid item container direction="row" justify="space-evenly">
      <Grid item {...ColProps_2} className={classes.block}>
        <CustomInput
          type="buy"
          currencyUnitName={quoteName}
          currencyName={currencyName}
          FirstCurrencyUnit={baseUnit}
          SecondCurrencyUnit={quoteUnit}
          walletInventory={state.BuyInventory}
        />
      </Grid>

      <Grid item {...ColProps_2}>
        <CustomInput
          type="sell"
          currencyUnitName={quoteName}
          currencyName={currencyName}
          FirstCurrencyUnit={baseUnit}
          SecondCurrencyUnit={quoteUnit}
          walletInventory={state.SellInventory}
        />
      </Grid>
    </Grid>
  );
};

export default LimitOrder;
